import iOverlays from './modules/overlays';
import iAutocomplete from './modules/autocomplete';
import iFilterAutocomplete from './modules/filterAutocomplete';
import iScrollTo from './modules/scrollTo';
import iStickyNav from './modules/sticky-nav';
import iBookmarker from './modules/bookmarker';
import immoSearchbox from './modules/immoSearchbox';
import immoExposeSwiper from './modules/exposeSwiper';
import immoStickySidebar from './modules/stickySidebar';
import immoCollapsible from './modules/collapsible';
import iExposeMap from './modules/maps';
import utm from './modules/utm';

// ====== Config ======
// eslint-disable-next-line no-restricted-globals
history.navigationMode = 'compatible';

// eslint-disable-next-line no-undef
$(() => {
    const I = {
        browserIsIe: false,
        browserDeviceCheck() {
            const ua = window.navigator.userAgent;
            const msie = ua.indexOf('MSIE ');
            const trident = ua.indexOf('Trident/');
            const edge = ua.indexOf('Edge/');
            if (msie > 0 || trident > 0 || edge > 0) {
                $('html').addClass('I_ie');
                this.browserIsIe = true;
            }
        },

        init() {
            console.log('init');
            iOverlays.init();
            iAutocomplete.init();
            iFilterAutocomplete.init();
            iScrollTo.init();
            iStickyNav.init();
            iBookmarker.init();
            immoSearchbox.init();
            immoStickySidebar();
            immoExposeSwiper();
            immoCollapsible();
            iExposeMap.init();
            utm.init();
        },
    };

    I.init();
});
